<div class="modal-header">
  <h2 class="modal-title mb-0 fs-3 fw-bold">
    {{ 'title.booking-change' | translate }}
  </h2>
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>

<div class="modal-body table-page-component">
  <div>
    <div class="d-flex justify-content-evenly mb-3" fxLayoutAlign="center" *ngIf="!!newEvent && !isLoading">
      <div class="border rounded p-3">
        <img
          *ngIf="bookingToUpdate.test?.logoPath"
          [src]="bookingToUpdate.test.logoPath"
          [alt]="bookingToUpdate.test.name"
          class="logo mb-3"
        />
        <p>
          {{ bookingToUpdate.test.name }}
        </p>
        <p>
          <span>
            {{
              'booking.default.details.timeFormat.dayOfWeek'
                | translate
                  : {
                      timeSlot:
                        oldEvent.testeventTime
                        | localizedDate: 'EEEE'
                    }
            }}
            <strong>
              <time
                [dateTime]="
                  oldEvent.testeventTime
                    | date: 'yyyy-MM-dd'
                "
              >
                {{
                  'booking.default.details.timeFormat.date'
                    | translate
                      : {
                          timeSlot:
                            oldEvent.testeventTime
                            | localizedDate: 'mediumDate'
                        }
                }}
              </time>
            </strong>
          </span>
          <br />
          <span>{{
            'booking.default.details.timeFormat.area'
              | translate
                : { testarea: oldEvent.testarea }
          }}</span>
          <time
            [dateTime]="
              oldEvent.testeventTime | date: 'HH:mm:ss'
            "
            >{{
              'booking.default.details.timeFormat.time'
                | translate
                  : {
                      timeSlot:
                        oldEvent.testeventTime
                        | localizedDate: 'shortTime'
                    }
            }}
          </time>
        </p>
        <p class="mb-0">
          {{ 'label.test-event-price' | translate }}:
          {{
            oldEvent.price.amount
              | currency
                : oldEvent.price.currency
                : undefined
                : undefined
                : currentLanguage
          }}
        </p>
      </div>

      <div gdAlignColumns="center">
        <i class="bi bi-arrow-right fs-1"></i>
      </div>

      <div class="border rounded p-3">
        <img
          *ngIf="bookingToUpdate.test?.logoPath"
          [src]="bookingToUpdate.test.logoPath"
          [alt]="bookingToUpdate.test.name"
          class="logo mb-3"
        />
        <p>
          {{ bookingToUpdate.test.name }}
        </p>
        <p>
          <span>
            {{
              'booking.default.details.timeFormat.dayOfWeek'
                | translate
                  : {
                      timeSlot:
                        newEvent.testeventTime
                        | localizedDate: 'EEEE'
                    }
            }}
            <strong>
              <time
                [dateTime]="
                  newEvent.testeventTime
                    | date: 'yyyy-MM-dd'
                "
              >
                {{
                  'booking.default.details.timeFormat.date'
                    | translate
                      : {
                          timeSlot:
                            newEvent.testeventTime
                            | localizedDate: 'mediumDate'
                        }
                }}</time
              >
            </strong>
          </span>
          <br />
          <span>{{
            'booking.default.details.timeFormat.area'
              | translate
                : { testarea: newEvent.testarea }
          }}</span>
          <time
            [dateTime]="
              newEvent.testeventTime | date: 'HH:mm:ss'
            "
            >{{
              'booking.default.details.timeFormat.time'
                | translate
                  : {
                      timeSlot:
                        newEvent.testeventTime
                        | localizedDate: 'shortTime'
                    }
            }}
          </time>
        </p>
        <p class="mb-0">
          {{ 'label.test-event-price' | translate }}:
          {{
            newEvent.price.amount
              | currency
                : newEvent.price.currency
                : undefined
                : undefined
                : currentLanguage
          }}
        </p>
      </div>
    </div>

    <div class="w-100 d-flex justify-content-center align-items-center mb-3" *ngIf="isLoading">
      <div class="spinner-grow text-info me-2" role="status"></div>
      <p class="mb-0">{{ 'message.please-wait' | translate }}</p>
    </div>

    <app-exam-event-statistics-table
      [currentTestEventId]="
        this.bookingToUpdate.testEventId
      "
      [searchFilters]="statisticsSearchFilters"
      (activeEventSet)="setActiveEvent($event)"
      (eventChosen)="newEventChosen($event)"
      [allowMultiSelect]="false"
    ></app-exam-event-statistics-table>
  </div>
</div>

<div class="modal-footer justify-content-between">
  <button
    class="btn btn-outline-primary"
    [disabled]="isLoading"
    (click)="bsModalRef.hide()"
  >
    {{ 'button.cancel' | translate }}
  </button>
  <button
    class="btn btn-primary"
    [disabled]="isLoading"
    (click)="changeBooking()"
  >
    {{ 'button.booking-change' | translate }}
  </button>
</div>
